import { COLORS } from '~/themes/common'

export const tags = {
  published: {
    label: 'Published',
    color: COLORS.palette.primaryBlue,
    bgColor: COLORS.palette.secondaryBlue3,
  },
  processing: {
    label: 'Processing',
    color: COLORS.palette.primaryBlue,
    bgColor: COLORS.palette.secondaryBlue3,
  },
  completed: {
    label: 'Completed',
    color: COLORS.accent.viridianGreen1,
    bgColor: COLORS.accent.viridianGreen2,
  },
  on_hold: {
    label: 'On Hold',
    color: COLORS.accent.apricotOrange1,
    bgColor: COLORS.accent.apricotOrange2,
  },
  pending: {
    label: 'Pending',
    color: COLORS.accent.starYellow,
    bgColor: COLORS.accent.mustardYellow2,
  },
  cancelled: {
    label: 'Cancelled',
    color: COLORS.accent.rubyRed1,
    bgColor: COLORS.accent.rubyRed2,
  },
  failed: {
    label: 'Failed',
    color: COLORS.palette.white,
    bgColor: COLORS.accent.rubyRed1,
  },
  refunded: {
    label: 'Refunded',
    color: COLORS.gray.textGray2,
    bgColor: COLORS.gray.disableGray2,
  },
  draft: {
    label: 'Draft',
    color: '#E0982F',
    bgColor: COLORS.accent.apricotOrange2,
  },

  future: {
    label: 'Future',
  },
  trash: {
    label: 'Trash',
  },
}
